var r=String.prototype.replace,t=/%20/g,e="RFC3986",n={default:e,formatters:{RFC1738:function(e){return r.call(e,t,"+")},RFC3986:function(r){return String(r)}},RFC1738:"RFC1738",RFC3986:e};export{n as f};
//# sourceMappingURL=formats.js.map
